import { render, staticRenderFns } from "./lottie-loader.vue?vue&type=template&id=6df39fd3"
import script from "./lottie-loader.vue?vue&type=script&lang=js"
export * from "./lottie-loader.vue?vue&type=script&lang=js"
import style0 from "./lottie-loader.vue?vue&type=style&index=0&id=6df39fd3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports